import * as React from 'react';

const CameraIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={22}
    fill="none"
    {...props}
  >
    <path
      stroke="#333"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M7.9 17.129a5.962 5.962 0 0 1-.65-2.71c0-3.613 2.99-6.58 6.63-6.58 3.64 0 6.63 2.967 6.63 6.58S17.52 21 13.88 21M3.09 21h21.32c1.3 0 2.34-1.032 2.34-2.323V6.935c0-1.29-1.04-2.322-2.34-2.322h-4.16c-.39 0-.65-.258-1.04-.645l-1.69-2.452c-.26-.258-.65-.516-.91-.516h-5.85c-.39 0-.65.258-.91.645L8.16 4.097c-.26.258-.65.516-.91.516H3.09c-1.3 0-2.34 1.032-2.34 2.322v11.613C.75 19.968 1.79 21 3.09 21Z"
    />
  </svg>
);

export default CameraIcon;
